import React, { useState } from "react";
import WebService from "../../Services/WebService";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./ForPass.css";

type ForgotPasswordResponse = {
  status_code: number;
  message?: string;
};

const ForgotPassword = () => {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendOtp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(mobile)) {
      Swal.fire("Error!", "Enter a valid 10 digit mobile number.", "error");
      return;
    }
    setLoading(true);
    try {
      const res = await WebService.postAPI({
        action: "/v1/door-management/forgot-password",
        body: {
          mobile_number: mobile,
          type: "FORGET_PASSWORD", 
        }
      }) as ForgotPasswordResponse;

      if (res.status_code === 200) {
        Swal.fire({
          title: "OTP Sent!",
          text: "Please check your phone for the OTP.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
          willClose: () => {
            navigate("/verifyOtp", { state: { mobile, type: "FORGET_PASSWORD" } });
          }
        });
      } else {
        Swal.fire("Error!", res.message || "Failed to send OTP. Try again.", "error");
      }
    } catch (err: any) {
      Swal.fire("Error!", "Network error. Please try again.", "error");
    }
    setLoading(false);
  };

return (
  <div
    className="login-bg"
    style={{
      background: `url(${process.env.PUBLIC_URL}/login.png) no-repeat left center/cover`,
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    }}
  >
    <form
      className="login-float-form"
      style={{ width: 380, maxWidth: "90vw" }}
      onSubmit={handleSendOtp}
      noValidate
    >
      <img src="/Assets/dm.png" alt="Logo" className="login-logo" />
      <h2 className="login-heading" style={{ marginBottom: 8 }}>
        Forgot Password
      </h2>
      <p className="login-subheading" style={{ marginBottom: 22 }}>
        Enter your registered mobile number to get an OTP.
      </p>
      <input
        type="tel"
        className="login-input"
        placeholder="Enter mobile number"
        value={mobile}
        maxLength={10}
        onChange={e => setMobile(e.target.value.replace(/\D/g, ""))}
        required
        disabled={loading}
      />
      <button className="login-btn" type="submit" disabled={loading}>
        {loading ? "Sending OTP..." : "Send OTP"}
      </button>
      <div style={{ marginTop: 22, width: "100%", textAlign: "left" }}>
        <a href="/login" className="login-register-link">Back to Login</a>
      </div>
    </form>
  </div>
);

};

export default ForgotPassword;
